module.exports = __webpack_public_path__ + "img/merbear_quiz_outline.8fa97484.png";